var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddressIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 31,
    viewBox: "0 0 30 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25 23.876V13.251C25 13.0569 24.9548 12.8655 24.868 12.692C24.7812 12.5184 24.6552 12.3674 24.5 12.251L15.75 5.68848C15.5336 5.5262 15.2705 5.43848 15 5.43848C14.7295 5.43848 14.4664 5.5262 14.25 5.68848L5.5 12.251C5.34476 12.3674 5.21875 12.5184 5.13197 12.692C5.04518 12.8655 5 13.0569 5 13.251V23.876C5 24.2075 5.1317 24.5254 5.36612 24.7599C5.60054 24.9943 5.91848 25.126 6.25 25.126H11.25C11.5815 25.126 11.8995 24.9943 12.1339 24.7599C12.3683 24.5254 12.5 24.2075 12.5 23.876V20.126C12.5 19.7945 12.6317 19.4765 12.8661 19.2421C13.1005 19.0077 13.4185 18.876 13.75 18.876H16.25C16.5815 18.876 16.8995 19.0077 17.1339 19.2421C17.3683 19.4765 17.5 19.7945 17.5 20.126V23.876C17.5 24.2075 17.6317 24.5254 17.8661 24.7599C18.1005 24.9943 18.4185 25.126 18.75 25.126H23.75C24.0815 25.126 24.3995 24.9943 24.6339 24.7599C24.8683 24.5254 25 24.2075 25 23.876Z",
    stroke: "#BDBDBD",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddressIcon);
export default __webpack_public_path__ + "static/media/address_icon.dd8dc90ea3a15cb70f8059f1d3854e23.svg";
export { ForwardRef as ReactComponent };